/**
 * @generated SignedSource<<291d23ced0d7d487acbc644314cf7358>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobTitleSection_person$data = {
  readonly contracts: ReadonlyArray<{
    readonly end_date: string | null | undefined;
    readonly id: number;
    readonly job_title: string | null | undefined;
    readonly start_date: string | null | undefined;
  }>;
  readonly id: number;
  readonly " $fragmentType": "JobTitleSection_person";
};
export type JobTitleSection_person$key = {
  readonly " $data"?: JobTitleSection_person$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobTitleSection_person">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobTitleSection_person",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "contracts",
      "kind": "LinkedField",
      "name": "contracts",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": "start_date",
          "args": null,
          "kind": "ScalarField",
          "name": "start_date_runn",
          "storageKey": null
        },
        {
          "alias": "end_date",
          "args": null,
          "kind": "ScalarField",
          "name": "end_date_runn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "job_title",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "people",
  "abstractKey": null
};
})();

(node as any).hash = "3c1c9c6eb1d0fb9e586f3eb87fcf86d4";

export default node;
